export default __webpack_public_path__ + "static/media/vid-01.35a49b68.mp4";